export const NAV = {
  logo: "nav-logo",
  home: "nav-link-home",
  about: "nav-link-about",
  herd: "nav-link-herd",
  bulls: "nav-link-bulls",
  heifers: "nav-link-heifers",
  services: "nav-link-services",
  contact: "nav-link-contact",
  menuToggle: "nav-menu-toggle",
  mobileMenu: "nav-mobile-menu",
};

export const HOME = {
  hero: "home-hero",
  heroCta: "home-hero-cta",
  heroSubCta: "home-hero-subcta",
  emergentLink: "home-emergent-link",
  chapter01: "home-chapter-01",
  chapter02: "home-chapter-02",
  chapter03: "home-chapter-03",
  marquee: "home-marquee",
  bullSpotlightCta: "home-bull-spotlight-cta",
};

export const BULL = {
  page: "bull-page",
  hero: "bull-hero",
  epdTable: "bull-epd-table",
  contactCta: "bull-contact-cta",
};

export const INQUIRY = {
  form: "inquiry-form",
  name: "inquiry-name-input",
  email: "inquiry-email-input",
  phone: "inquiry-phone-input",
  interest: "inquiry-interest-select",
  message: "inquiry-message-input",
  submit: "inquiry-submit-btn",
  success: "inquiry-success",
};

export const ADMIN = {
  page: "admin-inquiries-page",
  refresh: "admin-refresh-btn",
  row: "admin-inquiry-row",
};
